import { GroupPermission } from '@tenderd/track-web-utils';
import { Button } from 'antd';
import React from 'react';
import { useGroupPermissions } from '../../../../providers/useGroupPermissions';
import { i18n } from '../../../../translations';
import { AddRequestModalTKeys, GroupSettingsPageTKeys, } from '../../../../translations/keys';
import { GroupGeofenceMode, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
import MapIcon from './MapIcon';
var ModeActionHandler = function () {
    var _a = useGroupGeofencePageContext(), mode = _a.mode, setMode = _a.setMode, selectedGeofence = _a.selectedGeofence;
    var permissions = useGroupPermissions();
    if (!selectedGeofence) {
        return React.createElement(React.Fragment, null);
    }
    if (mode) {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, mode === GroupGeofenceMode.AddLocation
                ? i18n.t(GroupSettingsPageTKeys.clickToAddLocation)
                : i18n.t(GroupSettingsPageTKeys.drawToSetGeofence)),
            React.createElement(Button, { type: 'primary', ghost: true, onClick: function () {
                    setMode(undefined);
                }, style: { marginLeft: 10 } }, i18n.t(AddRequestModalTKeys.cancel))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "primary", ghost: true, style: {
                border: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
            }, onClick: function () {
                setMode(GroupGeofenceMode.AddLocation);
            }, icon: React.createElement(MapIcon, null) }, "Add Location Marker"),
        selectedGeofence.geofence.length &&
            permissions === GroupPermission.Admin ? (React.createElement(Button, { type: "primary", ghost: true, onClick: function () {
                setMode(GroupGeofenceMode.Geofence);
            } }, "Update Geofence")) : (React.createElement(React.Fragment, null, " "))));
};
export default ModeActionHandler;
